import { render } from "./TitleMessageModal.vue?vue&type=template&id=4b806465"
import script from "./TitleMessageModal.vue?vue&type=script&lang=js"
export * from "./TitleMessageModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b806465"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b806465', script)) {
    api.reload('4b806465', script)
  }
  
  module.hot.accept("./TitleMessageModal.vue?vue&type=template&id=4b806465", () => {
    api.rerender('4b806465', render)
  })

}

script.__file = "src/components/modals/TitleMessageModal.vue"

export default script